<template>
  <Swiper
    class="swiper"
    :modules="modules"
    :space-between="10"
    :autoplay="{ delay: 10000, disableOnInteraction: false }"
    :pagination="{ clickable: true, el: '.swiper-pagination' }"
    @swiper="onSwiper"
  >
    <!-- Premium lounge launch banner: VG-9905 -->
    <SwiperSlide class="swiper-slide split-banner" v-if="isLogin && isVIPAgent">
      <a
        class="banner-link"
        href="https://www.plazapremiumfirst.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div class="banner-content">
          <p class="banner-title">{{ $t('premium-lounge-banner-title') }}</p>
          <p class="banner-subtitle">{{ $t('premium-lounge-banner-desc') }}</p>
        </div>
        <img
          class="banner-image"
          src="~img/banner/PL-Launch-Banner.png"
          alt=""
          v-if="clientWidth > 1024"
        />
      </a>
    </SwiperSlide>
    <!-- openTable banner -->
    <SwiperSlide class="swiper-slide split-banner" v-if="isLogin && isVIPAgent">
      <div class="banner-content">
        <p class="banner-title">{{ $t('opentable-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('opentable-banner-desc') }}</p>
        <p class="banner-btn-text" @click="goToOpenTable">{{ $t('opentable-banner-btn') }}</p>
      </div>
      <img
        class="banner-image"
        src="~img/banner/open-table-banner.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- gigsky banner -->
    <SwiperSlide class="swiper-slide split-banner gigsky" v-if="isLogin && isVIPAgent">
      <div class="banner-content">
        <p class="banner-title">{{ $t('gigsky-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('gigsky-banner-desc') }}</p>
        <p class="banner-btn-text" @click="goToGigsky">{{ $t('gigsky-banner-btn') }} ></p>
      </div>
      <img
        class="banner-image"
        src="~img/banner/gigsky-banner.png"
        alt="GigSky"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- 未登录状态下展示的banner -->
    <SwiperSlide class="swiper-slide" v-if="!isLogin">
      <img class="img-item" src="~img/home_banner_1.png" alt="Banner" />
      <div class="signup-btn context-banner">
        <p class="singup-desc">
          {{ $t('limitless') }}
        </p>
        <button class="btn" @click="handleSignUp">{{ $t('signup') }}</button>
      </div>
    </SwiperSlide>
    <!--  R&C Benefits -->
    <SwiperSlide class="swiper-slide" v-if="isLogin && isVIPAgent">
      <!-- PC -->
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/banner/R&C_Benefits_pc.png"
        alt="Banner"
        v-if="clientWidth > 500"
      />
      <!-- Mobile -->
      <img
        class="img-item img-banner-visa-promotion content-fill"
        src="~img/banner/R&C_Benefits_mobile.png"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p class="singup-desc" v-html="$t('home-head-banner-desc-R&C-benefits')"></p>
        <button class="btn" @click="bookNow">{{ $t('btn-book-now') }}</button>
      </div>
    </SwiperSlide>
    <!-- 应用app store下载banner -->
    <SwiperSlide class="swiper-slide">
      <!-- PC -->
      <template v-if="clientWidth > 1024">
        <img
          class="img-item"
          src="~img/home_banner_2_fr.png"
          alt="Banner"
          v-if="$i18n.locale === 'fr_CA'"
        />
        <img class="img-item" src="~img/home_banner_2_en.png" alt="Banner" v-else />
      </template>
      <!-- Mobile -->
      <template v-if="clientWidth <= 1024">
        <img
          class="img-item img-item-mobile"
          v-if="$i18n.locale === 'fr_CA'"
          src="~img/mobilemobile-fr.png"
          alt="Banner"
        />
        <img class="img-item img-item-mobile" src="~img/mobilemobile-en.png" alt="Banner" v-else />
      </template>
      <div class="store-btn" role="banner store">
        <p class="store-desc1">
          {{ $t('limitless2') }}
        </p>
        <p class="store-desc2">
          {{ $t('download-visa-airport') }}
        </p>
        <div class="store-app">
          <!-- en_US 和 fr_CA 图片不一样通过class动态绑定，背景图实现 -->
          <button
            :class="$i18n.locale === 'fr_CA' ? 'appstore2' : 'appstore'"
            role="button"
            @click="clickApple"
          ></button>
          <button
            :class="$i18n.locale === 'fr_CA' ? 'googleplay2' : 'googleplay'"
            role="button"
            @click="clickAndroid"
          ></button>
        </div>
      </div>
    </SwiperSlide>
    <!-- Visa Destinations Banner  -->
    <SwiperSlide
      class="swiper-slide split-banner"
      v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)"
    >
      <div class="banner-content">
        <p class="banner-title">{{ $t('visa-destinations-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('visa-destinations-banner-desc') }}</p>
        <p class="banner-btn-text no-underline" @click="goToVisaDestinations">
          {{ $t('opentable-banner-btn') }}
        </p>
      </div>
      <img
        class="banner-image"
        src="~img/banner/destinations-banner.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- Park'N Fly Benefits  -->
    <SwiperSlide
      class="swiper-slide split-banner"
      v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)"
    >
      <div class="banner-content">
        <p class="banner-title">{{ $t('parknfly-banner-title') }}</p>
        <p class="banner-subtitle">{{ $t('parknfly-banner-desc') }}</p>
        <p class="banner-btn-text" @click="reserveNowTroonRewards">
          {{ $t('parknfly-banner-btn') }} >
        </p>
      </div>
      <img
        class="banner-image"
        src="~img/banner/Park-N-Fly-Benefits.png"
        alt="Banner"
        v-if="clientWidth > 1024"
      />
    </SwiperSlide>
    <!-- LuxuryHotelBanner -->
    <SwiperSlide class="swiper-slide" v-if="isLogin && (isVIAgent || isVIBAgent || isVIPAgent)">
      <img
        class="img-item img-banner-visa-promotion"
        v-if="$i18n.locale === 'fr_CA'"
        src="~img/luxury_hotel_fr.png"
        alt="Banner"
      />
      <img
        class="img-item img-banner-visa-promotion"
        src="~img/luxury_hotel_eng.png"
        alt="Banner"
        v-else
      />
      <div class="signup-btn context-banner">
        <p class="singup-desc" v-html="$t('home-head-banner-desc-luxury-hotel')"></p>
        <button class="btn" @click="letgo">{{ $t('btn-let-go') }}</button>
      </div>
    </SwiperSlide>
    <div class="swiper-pagination" v-show="swiperSidesLength > 1"></div>
  </Swiper>
</template>

<script>
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import { Autoplay, Pagination } from 'swiper/modules';
  import 'swiper/css';
  import 'swiper/css/pagination';
  import { mapState } from 'vuex';
  // VI卡种不同环境大客户id集合
  const VI_AGENTIDS = {
    local: ['18430', '18432', '18435', '18665', '18664'],
    test: [],
    uat: ['18430', '18432', '18435', '18665', '18664', '21420'],
    pre: ['19909', '19917', '19922', '20041', '20042', '37220'],
    production: ['19909', '19917', '19922', '20041', '20042', '37220'],
  };
  // VIB卡种不同环境大客户id集合
  const VIB_AGENTIDS = {
    local: ['18446', '18441', '18442'],
    test: [],
    uat: ['18446', '18441', '18442'],
    pre: ['19913', '19918', '19923'],
    production: ['19913', '19918', '19923'],
  };
  // VIP卡种不同环境大客户id集合
  const VIP_AGENTIDS = {
    local: ['18436', '18428', '18429', '18437', '18444', '18445', '18433', '18434', '18431'],
    test: [],
    uat: ['18436', '18428', '18429', '18437', '18444', '18445', '18433', '18434', '18431'],
    pre: [
      '19902',
      '19903',
      '19906',
      '19907',
      '19911',
      '19914',
      '19915',
      '19920',
      '19924',
      '40463',
      '41983',
    ],
    production: [
      '19902',
      '19903',
      '19906',
      '19907',
      '19911',
      '19914',
      '19915',
      '19920',
      '19924',
      '40463',
      '41983',
    ],
  };

  export default {
    data() {
      return {
        clientWidth: document.documentElement.clientWidth,
        swiperSidesLength: 0,
        modules: [Autoplay, Pagination],
      };
    },

    mounted() {
      window.addEventListener('resize', this.handleResize);
    },

    unmounted() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      handleResize() {
        this.clientWidth = document.documentElement.clientWidth;
      },
      onSwiper(swiper) {
        this.swiperSidesLength = swiper.slides.length;
      },
      letgo() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open('https://www.hotelsdeluxevisainfinite.ca/special-offers');
        } else {
          window.open('https://www.visainfiniteluxuryhotels.ca/special-offers');
        }
      },
      reserveNowTroonRewards() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open(
            'https://www.parknfly.ca/fr/emplacement/stationnement-a-laeroport-toronto/?coupon=1132060',
          );
        } else {
          window.open('https://www.parknfly.ca/location/toronto-airport-parking/?coupon=1132060');
        }
      },
      clickApple() {
        window.open('https://apps.apple.com/gb/app/visa-airport-companion/id1291608009');
      },

      clickAndroid() {
        window.open('https://play.google.com/store/apps/details?id=com.dragonpass.en.latam');
      },

      handleSignUp() {
        this.$router.push('/sign-up');
      },
      bookNow() {
        window.open('http://www.relaischateaux.com/us/osp/visa');
      },
      goToGigsky() {
        if (this.$i18n.locale === 'fr_CA') {
          window.open('https://www.gigsky.com/fr/visa/gigsky-visa-canada');
        } else {
          window.open(' https://www.gigsky.com/visa/gigsky-visa-canada');
        }
      },
      goToOpenTable() {
        window.open('https://www.opentable.ca/c/en/visadining/');
      },
      goToVisaDestinations() {
        window.open('https://destinations.visa.com/destinations/#/discover');
      },
    },

    computed: {
      ...mapState(['isLogin', 'userInfo']),
      isVIAgent() {
        const agentIds = [...VI_AGENTIDS[process.env.VUE_APP_CUSTOM_ENV]];
        return agentIds.includes(this.userInfo?.agentId);
      },
      isVIBAgent() {
        const agentIds = [...VIB_AGENTIDS[process.env.VUE_APP_CUSTOM_ENV]];
        return agentIds.includes(this.userInfo?.agentId);
      },
      isVIPAgent() {
        const agentIds = [...VIP_AGENTIDS[process.env.VUE_APP_CUSTOM_ENV]];
        return agentIds.includes(this.userInfo?.agentId);
      },
    },

    components: {
      Swiper,
      SwiperSlide,
    },
  };
</script>

<style lang="scss" scoped>
  @use './index.scss';
</style>
